import * as React from 'react';

import { ListPerformanceProps } from '../../components/list/performance';
import ListProduction from '../../components/list/production';

const ListProdPerformanceView: React.StatelessComponent<ListPerformanceProps> = props => {

    return (
        <li className="ace-production-row">
            <div className="ace-production-row-datetime">
                <p className="h2-secondary">
                    {
                        props.performance.productionDetailPageLink != null && props.performance.productionDetailPageLink.length > 0 ?
                            <a target="_blank" href={props.performance.productionDetailPageLink}>{props.performance.title}</a>
                            :
                            props.performance.title
                    }
                </p>
                <p className="h2-secondary flex-fiftyfifty">
                    <span>{props.performance.performanceDateDayString}</span>
                    <span>{props.performance.performanceTimeString}</span>
                </p>
            </div>

            <p className="h3-secondary">
                <span>{props.performance.facility.facilityDescription}</span>
            </p>
        </li>
    );
}

export default ListProdPerformanceView;